import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import home from '@/pages/home/home'
import training from '@/pages/home/training'
import Markpaper from '@/pages/home/Markpaper'
import homework from '@/pages/home/homework'
import operation from '@/pages/home/operation'
import homecourse from '@/pages/home/homecourse'
import courseshow from '@/pages/home/courseshow'
import courseware from '@/pages/home/courseware'
import allList from '@/pages/home/allList'
import tradet from '@/pages/home/tradet'
import coursewaredet from '@/pages/home/coursewaredet'
import search from '@/pages/home/search'
import personage from '@/pages/home/personage'
import practice from '@/pages/home/practice'

Vue.use(Router)

// 2. 定义一些路由
// 每个路由都需要映射到一个组件。
// 我们后面再讨论嵌套路由。
const routes = [{
    path: '/',
    name: 'HelloWorld',
    component: HelloWorld,
    redirect: '/courseware'
  },
  {
    path: '/home',
    name: 'home',
    component: home
  },
  {
    path: '/training',
    name: 'training',
    component: training
  },
  {
    path: '/Markpaper',
    name: 'Markpaper',
    component: Markpaper
  },
  {
    path: '/homework',
    name: 'homework',
    component: homework
  },
  {
    path: '/operation',
    name: 'operation',
    component: operation
  },
  {
    path: '/homecourse',
    name: 'homecourse',
    component: homecourse
  },
  {
    path: '/courseshow',
    name: 'courseshow',
    component: courseshow
  },
  {
    path: '/courseware',
    name: 'courseware',
    component: courseware
  },
  {
    path: '/allList',
    name: 'allList',
    component: allList
  },
  {
    path: '/tradet',
    name: 'tradet',
    component: tradet
  },
  {
    path: '/coursewaredet',
    name: 'coursewaredet',
    component: coursewaredet
  },
  {
    path: '/search',
    name: 'search',
    component: search
  },
  {
    path: '/personage',
    name: 'personage',
    component: personage
  },
  {
    path: '/practice',
    name: 'practice',
    component: practice
  }
]

// 3. 创建路由实例并传递 `routes` 配置
// 你可以在这里输入更多的配置，但我们在这里
// 暂时保持简单
const router = new Router({
  // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
  history: 'history',
  routes, // `routes: routes` 的缩写
})
console.log(localStorage.getItem('token'))
router.beforeEach((to, from, next) => {
  if (to.path !== "/home") {
    // 这里相当于我不是去登录，我想访问:比如说个人中心，我的文章等需要权限才能查看的数据
    if (window.localStorage.getItem('token')) {
      // 这里相当于你要去个人中心，而且我检查通过，那么，放行，return
      next();
      return;
    } else {
      //这里相当于我不是去登录页面，而且我啥权限也没有，那么肯定不让你去呀。直接滚回登录页
      next('/home');
      return;
    }
  } else {
    // 这你相当于你要去登录，那么正常去登录页就行
    next();
    return;
  }

});


export default router;

// export default new Router({
//   routes: [

//   ]
// }).beforeEach((to,from,next)=>{
//     console.log(to)
//     console.log(from)
//     document.title = to.matched[0].meta.title
//     next()
// })



// WEBPACK FOOTER //
// ./src/router/index.js